import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getData = async (id: string | undefined) => {
  const { data, error } = await supabase
    .from('hashtags')
    .select('*')
    .eq('id', id)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetHashtag(id: string | undefined) {
  return useQuery({
    queryKey: ['useGetHashtag'],
    queryFn: () => getData(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  })
}
